"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var Placeholder_1 = __importDefault(require("./styledComponents/Placeholder"));

var Heading_1 = __importDefault(require("./styledComponents/Heading"));

var UnorderedList_1 = __importDefault(require("./styledComponents/UnorderedList"));

var OrderedList_1 = __importDefault(require("./styledComponents/OrderedList"));

var ListItem_1 = __importDefault(require("./styledComponents/ListItem"));

var MultipartListItem_1 = __importDefault(require("./styledComponents/MultipartListItem"));

var MultipartListHeading_1 = __importDefault(require("./styledComponents/MultipartListHeading"));

var ListItemWrapper_1 = __importDefault(require("./styledComponents/ListItemWrapper"));

var FirstContent_1 = __importDefault(require("./styledComponents/FirstContent"));

var LastContent_1 = __importDefault(require("./styledComponents/LastContent"));

var Content_1 = __importDefault(require("./styledComponents/Content"));

var Translate_1 = __importDefault(require("../Translate/Translate"));

var mobx_1 = require("mobx");

var Tooltip_1 = __importDefault(require("../Tooltip/Tooltip"));

var List_meta_1 = require("./List.meta");

var List =
/** @class */
function (_super) {
  __extends(List, _super);

  function List(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = List_meta_1.LIST_CATEGORY_KEY;
    _this.componentKey = List_meta_1.LIST_COMPONENT_KEY;
    return _this;
  }

  List.prototype.getItemValue = function (item) {
    if (typeof item === 'string') {
      return react_1.default.createElement(Translate_1.default, null, item);
    }

    return item;
  };

  List.prototype.getItemPart = function (index, length) {
    var _a = this.props.itemStyle,
        itemStyle = _a === void 0 ? 'default' : _a;

    if (itemStyle === 'justified') {
      if (index === 0) {
        return FirstContent_1.default;
      }

      if (index === length - 1) {
        return LastContent_1.default;
      }
    }

    return Content_1.default;
  };

  List.prototype.isMultipartItem = function (items) {
    return Array.isArray(items) && items.length > 1;
  };

  List.prototype.getItemContent = function (items) {
    var _this = this;

    if (!Array.isArray(items) || items.length < 2) {
      return react_1.default.createElement(ListItem_1.default, null, react_1.default.createElement(Content_1.default, null, this.getItemValue(items)));
    }

    return react_1.default.createElement(MultipartListItem_1.default, null, items.map(function (item, index) {
      var ItemPart = _this.getItemPart(index, items.length);

      return react_1.default.createElement(ItemPart, {
        key: index
      }, _this.getItemValue(item));
    }));
  };

  Object.defineProperty(List.prototype, "blankDataOptions", {
    get: function get() {
      var _a = this.props.blankDataOptions,
          blankDataOptions = _a === void 0 ? {} : _a;
      var defaults = {
        showBlank: true,
        placeholder: 'No list data available'
      };
      return Object.assign(defaults, blankDataOptions);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(List.prototype, "isSingleItemList", {
    get: function get() {
      var items = this.props.items;
      return !!(items && items.length === 1);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(List.prototype, "listType", {
    get: function get() {
      var _a = this.props.type,
          type = _a === void 0 ? 'unordered' : _a;

      if (type === 'ordered') {
        return OrderedList_1.default;
      }

      return UnorderedList_1.default;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(List.prototype, "heading", {
    get: function get() {
      var _a = this.props,
          heading = _a.heading,
          headingTooltip = _a.headingTooltip;

      if (Array.isArray(heading)) {
        return react_1.default.createElement(Heading_1.default, {
          "data-multipart": true
        }, heading.map(function (headingPart, index) {
          return react_1.default.createElement(MultipartListHeading_1.default, {
            key: "heading_" + index
          }, react_1.default.createElement(Translate_1.default, null, headingPart), headingTooltip && index === 0 && react_1.default.createElement(Tooltip_1.default, __assign({}, headingTooltip)));
        }));
      }

      return heading && react_1.default.createElement(Heading_1.default, null, react_1.default.createElement(Translate_1.default, null, heading), headingTooltip && react_1.default.createElement(Tooltip_1.default, __assign({}, headingTooltip)));
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(List.prototype, "items", {
    get: function get() {
      var _this = this;

      var _a = this.props,
          _b = _a.items,
          items = _b === void 0 ? [] : _b,
          _c = _a.type,
          type = _c === void 0 ? 'unordered' : _c,
          props = __rest(_a, ["items", "type"]);

      var ListType = this.listType;
      var hasItems = items && items.length > 0;
      return hasItems ? react_1.default.createElement(ListType, __assign({}, props), items.map(function (item, index) {
        return react_1.default.createElement(ListItemWrapper_1.default, {
          key: index,
          "data-multipart": _this.isMultipartItem(item),
          "data-single-item": _this.isSingleItemList
        }, _this.getItemContent(item));
      })) : react_1.default.createElement(Placeholder_1.default, null, react_1.default.createElement(Translate_1.default, null, this.blankDataOptions.placeholder));
    },
    enumerable: true,
    configurable: true
  });

  List.prototype.render = function () {
    var className = this.props.className;
    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, this.heading, this.items);
  };

  __decorate([mobx_1.computed], List.prototype, "blankDataOptions", null);

  __decorate([mobx_1.computed], List.prototype, "isSingleItemList", null);

  __decorate([mobx_1.computed], List.prototype, "listType", null);

  __decorate([mobx_1.computed], List.prototype, "heading", null);

  __decorate([mobx_1.computed], List.prototype, "items", null);

  List = __decorate([mobx_react_1.observer], List);
  return List;
}(shared_1.ComponentBase);

exports.List = List;
exports.default = shared_1.InjectedStyledComponent(List, List_meta_1.LIST_CATEGORY_KEY, List_meta_1.LIST_COMPONENT_KEY);